import React from 'react';
import styled from 'styled-components';
import { Close } from '@material-ui/icons';
import { TextButton } from 'styles/theme-styled';

export const Reportar = styled.div`
    display: flex;
    width: 100%;
    padding: 30px 0;
    position: relative;

    @media (max-width: 768px) {
        justify-content: center;
    }
`;

// Botão para mostrar o diálogo
export const ReportButton = styled(TextButton)`
    && {
        color: #288394;
        text-decoration: underline;
        text-transform: none;
        font-weight: normal;
    }
`;

export const BoxCheckDenuncia = styled.div`
    &:last-child {
        margin-bottom: 10px;
    }

`;

export const ReportFormTitle = styled.div`
    width: 100%;
    background-color: #fff;

    span {
        display: block;
        background: #ffff;
        font-weight: bold;
        left: 0;
        font-size: 1.5rem;
        color: #30bcd5;
    }

    @media (max-width: 600px) {
        margin-bottom: 20px;
        span {
            font-size: 18px;
            padding: 0 10px 0 40px;
        }
    }
`;

export const BoxReportForm = styled.div`
    min-width: ${(props) => !props.isMobile && '500px'};
    min-height: 600px;
    background-color: white;
    padding: 40px;

    overflow: auto;
`;

export const ReportFeedbackContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    padding: 0 20px;
    background-color: white;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    position: absolute;
`;

export const CloseFormButton = styled((props) => (
    <div {...props}>
        <CloseFormButton.CloseIcon />
    </div>
))`
    && {
        display: inline-flex;
        justify-content: flex-end;
    }
`;

CloseFormButton.CloseIcon = styled(Close)`
    && {
        font-size: 50px;
        color: #ffffff;
        cursor: pointer;
    }
`;
